import { render, staticRenderFns } from "./inputFile.pug?vue&type=template&id=4c367e7c&lang=pug&"
import script from "./inputFile.js?vue&type=script&lang=js&"
export * from "./inputFile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c367e7c')) {
      api.createRecord('4c367e7c', component.options)
    } else {
      api.reload('4c367e7c', component.options)
    }
    module.hot.accept("./inputFile.pug?vue&type=template&id=4c367e7c&lang=pug&", function () {
      api.rerender('4c367e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/file/index.vue"
export default component.exports